import { useEffect, useState } from "react";
import {
    Box,
    Button,
    // Collapse,
    Divider,
    // FormControlLabel,
    Grid2 as Grid,
    // Switch,
    Tooltip,
    Typography
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { PaymentMethodPreview } from "../../../Shared/PaymentMethodPreview";
import {
    FormAlert,
    // FormAutocomplete,
    FormDatePicker,
    // FormMultiSelect,
    // FormSelect,
    FormTextField,
} from "../../../Shared/Form";
// import { countryList, countriesWithProvinces, positionList } from "../../../../config/constants";
// import { State, City } from "country-state-city";
import { CreateCampaignViewModelType } from "../ViewModel";

type AudiencePageType = {
    viewModel: CreateCampaignViewModelType;
    setNextStepDisabled: (v: boolean) => void;
    isLoading: boolean;
    handleChangePaymentMethod: () => void;
}

const AudiencePage = ({ viewModel, setNextStepDisabled, isLoading, handleChangePaymentMethod }: AudiencePageType) => {
    const {
        // ageMin,
        // setAgeMin,
        // ageMax,
        // setAgeMax,
        // hittingHand,
        // setHittingHand,
        // throwingHand,
        // setThrowingHand,
        // positions,
        // setPositions,
        // country,
        // setCountry,
        // state,
        // setState,
        // city,
        // setCity,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        dailyBudget,
        setDailyBudget,
    } = viewModel;

    // const [targetAllUsers, setTargetAllUsers] = useState(false);
    const [alert, setAlert] = useState(false);

    // const [states, setStates] = useState([]);
    // const [cities, setCities] = useState([]);

    // const getStateLabel = useCallback(() => {
    //     return countriesWithProvinces.includes(country?.value) ? "Province" : "State";
    // }, [country]);

    // const handleSwitch = (e) => {
    //     const checked = e.target.checked;
    //     setTargetAllUsers(checked);
    //     if (checked) {
    //         setAgeMin("");
    //         setAgeMax("");
    //         setHittingHand("");
    //         setThrowingHand("");
    //         setPositions([]);
    //         setCountry(null);
    //         setState(null);
    //         setCity(null);
    //     }
    // }

    // const handleCountryChange = (v) => {
    //     setCountry(v);
    //     setState(null);
    //     setCity(null);
    // }

    // const handleStateChange = (v) => {
    //     setState(v);
    //     setCity(null);
    // }

    // useEffect(() => {
    //     if (country !== null) {
    //         setStates(State.getStatesOfCountry(country?.value).map((state) => {
    //             return { value: state.isoCode, label: state.name }
    //         }));
    //     }
    // }, [country])

    // useEffect(() => {
    //     if (state !== null) {
    //         setCities(City.getCitiesOfState(country?.value, state?.value).map((city) => {
    //             return { value: city.name, label: city.name }
    //         }));
    //     }
    // }, [country, state])

    // const [ageError, setAgeError] = useState("");
    const [dailyBudgetError, setDailyBudgetError] = useState("");
    const [dateError, setDateError] = useState("");

    const handleDailyBudgetChange = (newValue: string) => {
        const filteredValue = newValue.replace(/[^\d.]/g, '');
        setDailyBudget(filteredValue);
        if (filteredValue === "") {
            setDailyBudgetError("Please enter a budget");
        } else if (/^\$?\d+(\.\d{0,2})?$/.test(filteredValue)) {
            if (parseFloat(filteredValue) > 1000) {
                setDailyBudgetError("Budget cannot exceed $1000")
            } else {
                setDailyBudgetError("");
            }
        } else {
            setDailyBudgetError("Input a valid currency");
        }
    }

    // useEffect(() => {
    //     if (ageMin && ageMax && parseInt(ageMin) > parseInt(ageMax)) {
    //         setAgeError("Must be lower than the age max")
    //     } else {
    //         setAgeError("");
    //     }
    // }, [ageMin, ageMax])

    useEffect(() => {
        if (startTime && startTime.unix() * 1000 <= Date.now()) {
            setDateError("Cannot start before tomorrow")
        } else if (startTime && endTime && endTime.unix() < startTime.unix()) {
            setDateError("Must be before the end time");
        } else {
            setDateError("");
        }
    }, [startTime, endTime])

    useEffect(() => {
        // if (dailyBudgetError || ageError || dateError || startTime === null || endTime === null) {
        if (dailyBudgetError || dateError || startTime === null || endTime === null) {
            setNextStepDisabled(true);
        } else {
            setNextStepDisabled(false);
        }
    }, [dailyBudgetError, dateError, startTime, endTime, setNextStepDisabled])

    return (
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
            <Box display="flex" flexDirection="column" gap={1} pt={2}>
                <Typography>
                    This campaign will target all users on the platform.
                </Typography>
                <Typography>
                    As Statrat's user base grows, targeting based on position, current player equipment,
                    and other demographic factors will be added.
                </Typography>
            </Box>
            <Divider sx={{ mt: 2, mb: 2 }} />
            {/* <Box display="flex" gap={1} alignItems="center" pt={2}>
                <Tooltip
                    title={`By leaving all options blanks, your ad will be shown to all users
                        and not just a specific demographic`}
                    followCursor
                >
                    <FormControlLabel
                    control={<Switch checked={targetAllUsers} onChange={handleSwitch} />}
                    label="Target Ad to All Users"
                    labelPlacement="start"
                    disabled={isLoading}
                    sx={{ marginLeft: 0 }}
                />
                </Tooltip>
            </Box>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Collapse in={!targetAllUsers}>
                <Typography variant="h6" pb={2}>User Info</Typography>
                <Grid container spacing={3} width={"100%"}>
                    <FormSelect
                        id = "age-min-label"
                        label = "Age Min"
                        value = {ageMin}
                        setValue = {setAgeMin}
                        items = {["5", "10", "15", "20", "25", "30", "35", "40", "45", "50"]}
                        disabled={isLoading || targetAllUsers}
                        error={ageError}
                        size={2}
                    />
                    <FormSelect
                        id = "age-max-label"
                        label = "Age Max"
                        value = {ageMax}
                        setValue = {setAgeMax}
                        items = {["5", "10", "15", "20", "25", "30", "35", "40", "45", "50"]}
                        disabled={isLoading || targetAllUsers}
                        size={2}
                    />
                    <FormSelect
                        id = "hitting-hand-label"
                        label = "Hitting Hand"
                        value = {hittingHand}
                        setValue = {setHittingHand}
                        items = {["Right", "Left"]}
                        itemValues={["RHB", "LHB"]}
                        disabled={isLoading || targetAllUsers}
                    />
                    <FormSelect
                        id = "throwing-hand-label"
                        label = "Throwing Hand"
                        value = {throwingHand}
                        setValue = {setThrowingHand}
                        items = {["Right", "Left"]}
                        itemValues={["RHT", "LHT"]}
                        disabled={isLoading || targetAllUsers}
                    />
                </Grid>
                <Typography variant="h6" pt={2} pb={2}>Location</Typography>
                <Grid container spacing={3} width={"100%"}>
                    <FormAutocomplete
                        label = "Country"
                        value = {country}
                        setValue = {handleCountryChange}
                        items = {countryList}
                        disabled={isLoading || targetAllUsers}
                    />
                    <FormAutocomplete
                        label = {getStateLabel()}
                        value = {state}
                        setValue = {handleStateChange}
                        items = {states}
                        disabled = {country === null || isLoading || targetAllUsers}
                    />
                    <FormAutocomplete
                        label = "City"
                        value = {city}
                        setValue = {setCity}
                        items = {cities}
                        disabled = {state === null || isLoading || targetAllUsers}
                    />
                </Grid>
                <Divider sx={{ mt: 4, mb: 3 }} />
                <Typography variant="h6">Other Info</Typography>
                <Grid container spacing={3} width={"100%"}>
                    <FormMultiSelect
                        id = "positions-label"
                        label = "Positions"
                        value = {positions}
                        setValue = {setPositions}
                        items = {positionList}
                        disabled={isLoading || targetAllUsers}
                        limit={3}
                    />
                </Grid>
                <Divider sx={{ mt: 4, mb: 3 }} />
            </Collapse> */}
            <Box display="flex" gap={1} alignItems="center" pb={2}>
                <Tooltip
                    title={`Daily Budget only indicates the maximum amount you may be charged in one day before
                        your ad is no longer shown to users.`}
                >
                    <InfoOutlined />
                </Tooltip>
                <Typography variant="h6">Budget and Schedule</Typography>
            </Box>
            <Grid container spacing={3} width={"100%"}>
                <FormTextField
                    label="Daily Budget"
                    value={dailyBudget}
                    setValue={handleDailyBudgetChange}
                    helperText={"Required"}
                    disabled={isLoading}
                    error={dailyBudgetError}
                    inputAdornment="$"
                    size={3}
                />
                <FormDatePicker
                    label="Start Time"
                    value={startTime}
                    setValue={setStartTime}
                    required={true}
                    error={dateError}
                    disabled={isLoading}
                    includeTime={true}
                    disablePast={true}
                    excludeToday={true}
                    size={4.5}
                />
                <FormDatePicker
                    label="End Time"
                    value={endTime}
                    setValue={setEndTime}
                    required={true}
                    disabled={isLoading}
                    includeTime={true}
                    disablePast={true}
                    excludeToday={true}
                    size={4.5}
                />
            </Grid>
            <Divider sx={{ mt: 4, mb: 3 }} />
            <Typography variant="h6" pb={2}>Payment Method</Typography>
            <Grid container display="flex" gap={3}>
                <PaymentMethodPreview />
                <Grid display="flex" flexDirection="column" gap={3}>
                    <Typography marginTop="auto" component="pre">
                        The following card will be used to request payment once eligible.{"\n"}
                        You will not be charged anything for creating the ad.{"\n"}
                        More information about payment can be found in the Help page.
                    </Typography>
                    <Button
                        onClick={() => { setAlert(true) }}
                        variant="contained"
                        sx={{ width: '290px' }}
                        disabled={isLoading}
                    >
                        Change Payment Method
                    </Button>
                </Grid>
            </Grid>
            <FormAlert
                label="redirect-payment"
                open={alert}
                setOpen={setAlert}
                description={`
                    To change payment method, you will be redirected to Settings.
                    To continue, save this campaign as a draft first.
                    Note: Start Time and End Time must be set before saving the campaign as a draft.
                `}
                handleAgree={handleChangePaymentMethod}
                disabled={isLoading}
                agreeText={"Save as Draft and Move to Settings"}
            />
        </div>
    )
}

export default AudiencePage;
